<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-3">
          <li class="breadcrumb-item">
            <a
              href="#"
              @click.prevent="$router.go(-1)"
            >
              <feather type="arrow-left" />
              {{ $t('editRequest.geri') }}
            </a>
          </li>
        </ol>
      </div>
    </div>
    <div class="clearfix" />
    <!-- Container-fluid starts-->
    <div
      v-if="request"
      class="container"
    >
      <h3 class="mb-3">
        #{{ request.requestType }}{{ buildLongId(request.id) }}
      </h3>


      <input
        id="fileInput"
        ref="file"
        type="file"
        style="display: none"
        @change="setPhoto"
      >

      <div
        v-if="['RFI','RFQ','PQT', 'REV','AUC'].indexOf(request.requestType)>-1
          || (request.requestType==='OFR' && profile !== 'LOGISTIC') "
        class="card shadow"
      >
        <div class="card-body">
          <h4>
            <span v-if="request.requestType==='AUC'">{{ $t('newAUCRequest.hrracnzHansSahyAiddir') }}</span>
            <span v-else-if="request.requestType==='REV'">{{ $t('newRevRequest.ksHrracnzHansSahyAiddir') }}</span>
            <span v-else-if="request.requestType==='OFR'">{{ $t('newOfferRequest.tklifinizHansSahyAiddir') }}</span>
            <span v-else>{{ $t('newInfoRequest.sorunuzHansSahyAiddir') }}</span>
          </h4>

          <p>
            {{ $t('newAUCRequest.sorununYaradarknFaliyytSahsiniSemkMtlqdirSizMaximu') }}
          </p>

          <div class="mt-3">
            <button
              v-b-modal.modal-sector-selection
              type="button"
              class="btn btn-sm btn-light-primary"
            >
              {{ $t('companyProfile.faliyytSahsiniSein') }}
            </button>
          </div>

          <hr v-if="requestSectors.length>0">
          <SelectedSectorView
            :sectors="requestSectors"
            :parent-id="0"
          />
        </div>
      </div>
      <form @submit.prevent="createRequest">
        <div class="card shadow">
          <div class="card-body">
            <div class="mb-3">
              <label v-if="['REV','AUC'].indexOf(request.requestType)>-1"> {{ $t('newAUCRequest.hrracnAd') }}</label>
              <label v-else-if="['POL'].indexOf(request.requestType)>-1"> {{ $t('newPolRequest.ssvermMvzusununBal') }}</label>
              <label v-else-if="['ORF'].indexOf(request.requestType)>-1"> {{ $t('editRequest.tklifinBal') }}</label>
              <label v-else>{{ $t('newInfoRequest.soruBal') }}</label>
              <b-form-input
                id="new_request_title"
                v-model="requestTitle"
                type="text"
                required
              />
            </div>

            <div
              v-if="['LOG','TRS','TRS','TRK'].indexOf(request.requestType)===-1"
              class="mb-3"
            >
              <span v-if="['REV','AUC'].indexOf(request.requestType)>-1">{{ $t('editRequest.hrracBarddMlumatlar') }}</span>
              <span v-else-if="['POL'].indexOf(request.requestType)>-1">{{ $t('newPolRequest.ssvermMvzusununMtni') }}</span>
              <span v-else-if="['OFR'].indexOf(request.requestType)>-1">{{ $t('editRequest.tklifMtni') }}</span>
              <span v-else>{{ $t('newInfoRequest.soruMtni') }}</span>
              <b-form-textarea
                id="new_request_description"
                v-model="requestDescription"
                required
                rows="4"
              />
            </div>
          </div>
        </div>


        <div
          v-if="requestType === 'PQT'"
          class="card shadow"
        >
          <div class="card-body">
            <h4>{{ $t('newRFQRequest.ilkinZruriTlblr') }}</h4>
            <hr>
            <div class="mb-3">
              <label>{{ $t('newRFQRequest.valyuta') }}</label>
              <div class="input-group">
                <select
                  v-model="orderExtras.currency"
                  class="form-control"
                  min="1"
                  required
                >
                  <option value="AZN">
                    {{ $t('newAUCRequest.azn') }}
                  </option>
                  <option value="USD">
                    {{ $t('newRFQRequest.usd') }}
                  </option>
                  <option value="EUR">
                    {{ $t('newRFQRequest.eur') }}
                  </option>
                </select>
                <div class="input-group-append">
                  <span class="input-group-text">-</span>
                </div>
                <select
                  v-model="orderExtras.currencyRequired"
                  class="form-control"
                  min="1"
                  required
                >
                  <option value="yes">
                    {{ $t('pqtExtrasView.mtlq') }}
                  </option>
                  <option value="no">
                    {{ $t('pqtExtrasView.arzuOlunan') }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('newRFQRequest.incotermsRtlri2020') }}</label>
              <div class="input-group">
                <select
                  v-model="orderExtras.incoterms"
                  class="form-control"
                  min="1"
                  required
                >
                  <option value="NONE">
                    {{ $t('offerExtrasView.yoxdur') }}
                  </option>
                  <option
                    v-for=" i in inctermsList"
                    :key="i"
                    :value="i"
                  >
                    {{ i }}
                  </option>
                </select>
                <div class="input-group-append">
                  <span class="input-group-text">-</span>
                </div>
                <select
                  v-if="orderExtras.incoterms && orderExtras.incoterms !=='NONE'"
                  v-model="orderExtras.incotermsRequired"
                  class="form-control"
                  min="1"
                  required
                >
                  <option value="yes">
                    {{ $t('pqtExtrasView.mtlq') }}
                  </option>
                  <option value="no">
                    {{ $t('pqtExtrasView.arzuOlunan') }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <label>{{ $t('newRFQRequest.dniSulu') }}</label>
              <div class="input-group">
                <select
                  v-model="orderExtras.payment"
                  class="form-control"
                  min="1"
                  required
                >
                  <option value="transfer">
                    {{ $t('offerExtrasView.krm') }}
                  </option>
                  <option value="cash">
                    {{ $t('offerExtrasView.nad') }}
                  </option>
                  <option value="both">
                    {{ $t('offerExtrasView.hrIkisi') }}
                  </option>
                </select>
                <div class="input-group-append">
                  <span class="input-group-text">-</span>
                </div>
                <select
                  v-model="orderExtras.paymentRequired"
                  class="form-control"
                  min="1"
                  required
                >
                  <option value="yes">
                    {{ $t('pqtExtrasView.mtlq') }}
                  </option>
                  <option value="no">
                    {{ $t('pqtExtrasView.arzuOlunan') }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <label>{{ $t('newRFQRequest.atdrlma') }}</label>
              <div class="input-group">
                <select
                  v-model="orderExtras.deliveryNeeded"
                  class="form-control"
                  min="1"
                  required
                >
                  <option value="yes">
                    {{ $t('newRFQRequest.lazmdr') }}
                  </option>
                  <option value="no">
                    {{ $t('newRFQRequest.lazmDeyil') }}
                  </option>
                </select>
                <input
                  v-if="orderExtras.deliveryNeeded && orderExtras.deliveryNeeded==='yes' "
                  v-model.number="orderExtras.delivery"
                  type="number"
                  class="form-control"
                  min="1"
                  required
                >

                <div
                  v-if="orderExtras.deliveryNeeded && orderExtras.deliveryNeeded==='yes' "
                  class="input-group-append"
                >
                  <span class="input-group-text">
                    {{ $t('newRFQRequest.gnRzind') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label>{{ $t('newRFQRequest.ilkinZruriTlblrlBalQeydlr') }}</label>

              <div>
                <textarea
                  v-model.trim="orderExtras.initialRequirementNotes"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="request.requestType === 'AUC'"
          class="card shadow"
        >
          <div class="card-body">
            <div class="mb-3 w-50">
              <label>{{ $t('newAUCRequest.balancQiymt') }}</label>
              <div class="input-group">
                <b-form-input
                  v-model="orderExtras.startingPrice"
                  type="number"
                  min="1"
                  required
                />
                <div class="input-group-append">
                  <div class="input-group-text">
                    {{ $t('newAUCRequest.azn') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-else-if="request.requestType === 'POL'"
          class="card shadow"
        >
          <div class="card-body">
            <div class="mb-3">
              <label>{{ $t('newPolRequest.birNeCavabSeilBilrmi') }}</label>
              <br>
              <div class="ml-2">
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      id="multiSelectYes"
                      v-model="orderExtras.multiSelect"
                      type="radio"
                      name="multiSelect"
                      class="custom-control-input"
                      :value="1"
                    >
                    <label
                      class="custom-control-label"
                      for="multiSelectYes"
                    >{{ $t('newPolRequest.bli') }}</label>
                  </div>
                </div>
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline ml-3">
                    <input
                      id="multiSelectNo"
                      v-model="orderExtras.multiSelect"
                      type="radio"
                      name="multiSelect"
                      class="custom-control-input"
                      :value="0"
                    >
                    <label
                      class="custom-control-label"
                      for="multiSelectNo"
                    >{{ $t('newPolRequest.xeyr') }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('newPolRequest.istifadiZCavabVariantnLavEdBilrmi') }}</label>
              <br>
              <div class="ml-2">
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      id="ownVariantYes"
                      v-model="orderExtras.ownVariant"
                      type="radio"
                      name="ownVariant"
                      class="custom-control-input"
                      :value="1"
                    >
                    <label
                      class="custom-control-label"
                      for="ownVariantYes"
                    >{{ $t('newPolRequest.bli') }}</label>
                  </div>
                </div>
                <div class="radio radio-primary d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline ml-3">
                    <input
                      id="ownVariantNo"
                      v-model="orderExtras.ownVariant"
                      type="radio"
                      name="ownVariant"
                      class="custom-control-input"
                      :value="0"
                    >
                    <label
                      class="custom-control-label"
                      for="ownVariantNo"
                    >{{ $t('newPolRequest.xeyr') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="request.requestType === 'LOG'">
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpAddress"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4>
                {{ $t('newLogisticRequest.sonMntq') }}
              </h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffAddress"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow">
            <div class="card-body">
              <div class="mb-3">
                <label>{{ $t('newLogisticRequest.sorununDvriliyiVDigrQeydlr') }}</label>
                <b-form-textarea
                  v-model="orderExtras.notes"
                  required
                  rows="4"
                />
              </div>

              <div class="w-50">
                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.satcIlRazladnzIncotermsRti') }}</label>
                  <select
                    v-model="orderExtras.incoterms"
                    class="form-control"
                    required
                  >
                    <option
                      v-for=" i in inctermsList"
                      :key="i"
                      :value="i"
                    >
                      {{ i }}
                    </option>
                  </select>
                </div>

                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.hansNvDanmalarNTklifAlmaqIstyirsiniz') }}</label>

                  <multiselect
                    v-model="orderExtras.types"
                    :placeholder="$t('newLogisticRequest.danmaNvnSein')"
                    :label="$t('newLogisticRequest.value')"
                    track-by="key"
                    :options="typeList"
                    :multiple="true"
                  />
                  <div class="text-secondary ml-1">
                    {{ $t('newLogisticRequest.birNeDanmaNvSeBilrsiniz') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="request.requestType === 'TRS'">
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpAddress"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newTRSRequest.yknXacaTarix') }}</label>
                    <DatePicker
                      v-model="orderExtras.deadline"
                      mode="date"

                      :min-date="minDeadline"
                      :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                      :is-required="true"
                      :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                    >
                      <template #default="{ inputValue, inputEvents }">
                        <input
                          type="text"
                          class="form-control "
                          :value="inputValue"
                          placeholder=""
                          required
                          v-on="inputEvents"
                        >
                      </template>
                    </DatePicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4>
                {{ $t('newLogisticRequest.sonMntq') }}
              </h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('nvanIstiqamt') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffAddress"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="request.requestType === 'TRK'">
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
              <hr>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.pickUpCity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.yolaDmTarixi') }}</label>
                    <DatePicker
                      v-model="orderExtras.deadline"
                      mode="date"
                      :min-date="minDeadline"
                      :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                      :is-required="true"
                      :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                    >
                      <template #default="{ inputValue, inputEvents }">
                        <input
                          type="text"
                          class="form-control "
                          :value="inputValue"
                          placeholder=""
                          required
                          v-on="inputEvents"
                        >
                      </template>
                    </DatePicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newLogisticRequest.sonMntq') }}</h4>
              <hr>

              <div class=" row ">
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.lk') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCountry"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class=" mb-3">
                    <label>{{ $t('newLogisticRequest.hr') }}</label>
                    <b-form-input
                      v-model="orderExtras.dropOffCity"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.qeydlr') }}</label>

                    <b-form-textarea
                      v-model="requestDescription"
                      rows="3"
                      required
                    />
                    <span class="text-secondary">{{ $t('newTRKRequest.yolStYkGtrlBilckHrlrinAdnQeydEdBilrsiz') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('newTRKRequest.ykHaqqndaMlumatlar') }}</h4>
              <hr>

              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.ykQbulEdckTrnNv') }}</label>

                    <multiselect
                      v-model="orderExtras.truckType"
                      :placeholder="$t('newTRKRequest.trNvnSein')"
                      :label="$t('newTRKRequest.name')"
                      track-by="key"
                      :options="truckTypeList"
                      :multiple="false"
                    >
                      <template
                        slot="singleLabel"
                        slot-scope="props"
                      >
                        <div style="line-height: 1.4; font-size: 12px;">
                          <strong>{{ props.option.name }}</strong> <br>
                          <span style="white-space: pre">{{ props.option.description }}</span>
                        </div>
                      </template>


                      <template
                        slot="option"
                        slot-scope="props"
                      >
                        <div style="line-height: 1.4; font-size: 12px;">
                          <strong>{{ props.option.name }}</strong> <br>
                          <span style="white-space: pre">{{ props.option.description }}</span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="col-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.hansNvYklrQbulEdilir') }}</label>

                    <multiselect
                      v-model="orderExtras.types"
                      :placeholder="$t('newTRKRequest.ykNvnSein')"
                      :label="$t('newLogisticRequest.value')"
                      track-by="key"
                      :options="advTypeList"
                      :multiple="true"
                    />
                  </div>
                </div>

                <div
                  v-if="orderExtras.types.find(t=>t.key==='dangerous')"
                  class="col-12"
                >
                  <div class="mb-3 ml-2">
                    <div class="checkbox checkbox-success">
                      <b-form-checkbox
                        v-model="orderExtras.driverHasAdr"
                        :value="1"
                      >
                        {{ $t('newTRKRequest.srcnnAdrIcazsiVarm') }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>


                <div class="col-md-6">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.yknMiqdar') }}</label>
                    <b-form-input
                      v-model.number="orderExtras.loadSize"
                      type="number"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label>{{ $t('newOfferRequest.lVahidi') }}</label>
                    <select
                      v-model="orderExtras.loadUnit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in loadUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.danmaQiymti') }}</label>

                    <div class="input-group">
                      <b-form-input
                        v-model.number="orderExtras.priceVolume"
                        type="number"
                        step="0.01"
                        required
                      />
                      <div class="input-group-text">
                        {{ $t('newTRKRequest.n', {expr: orderExtras.loadUnit || '-'}) }}
                      </div>

                      <b-form-input
                        v-model.number="orderExtras.pricePrice"
                        type="number"
                        step="0.01"
                        required
                      />
                      <div class="input-group-text">
                        {{ $t('newAUCRequest.azn') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.qiymtlBalQeydlr') }}</label>

                    <b-form-textarea
                      v-model="orderExtras.priceNotes"
                      rows="3"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="requestType === 'OFR'"
          class="card shadow"
        >
          <div class="card-body">
            <h4>{{ $t('newOfferRequest.tklifDetallar') }}</h4>
            <hr>

            <div class="w-50">
              <div v-if="requestSubType==='wholesale'">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-sm-6 mb-3">
                      <label> {{ $t('newOfferRequest.minimumSifariMiqdar') }}</label>
                      <b-form-input
                        v-model.number="orderExtras.minOrder"
                        type="number"
                        required
                      />
                    </div>
                    <div class="col-sm-6 mb-3">
                      <label>{{ $t('newOfferRequest.lVahidi') }}</label>
                      <select
                        v-model="orderExtras.unit"
                        class="form-control"
                        required
                      >
                        <option
                          v-for="v in loadUnits"
                          :key="v"
                          :value="v"
                        >
                          {{ v }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class=" mb-3">
                    <label> {{ $t('newOfferRequest.topdanSatQiymti1N', {unit: orderExtras.unit}) }}</label>
                    <div class="input-group">
                      <b-form-input
                        v-model.number="orderExtras.price"
                        type="number"
                        required
                      />
                      <div class="input-group-text">
                        <strong>{{ $t('newAUCRequest.azn') }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6 mb-3">
                  <label> {{ $t('newOfferRequest.dniSulu') }}</label>
                  <select
                    v-model="orderExtras.payment"
                    class="form-control"
                    required
                  >
                    <option value="transfer">
                      {{ $t('offerExtrasView.krm') }}
                    </option>
                    <option value="cash">
                      {{ $t('offerExtrasView.nad') }}
                    </option>
                    <option value="both">
                      {{ $t('offerExtrasView.hrIkisi') }}
                    </option>
                  </select>
                </div>
                <div
                  v-if="requestSubType!=='service' && requestSubType !==''"
                  class="col-sm-6 mb-3"
                >
                  <label> {{ $t('newOfferRequest.atdrlma') }}</label>
                  <select
                    v-model="orderExtras.delivery"
                    class="form-control"
                    required
                  >
                    <option value="no">
                      {{ $t('offerExtrasView.yoxdur') }}
                    </option>
                    <option value="yes">
                      {{ $t('offerExtrasView.qiymtDaxildir') }}
                    </option>
                    <option value="paid">
                      {{ $t('offerExtrasView.qiymtDaxilDeyil') }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow">
          <div class="card-body">
            <div
              v-if="requestType !=='OFR'"
              class="mb-3 w-50"
            >
              <label v-if="request.requestType==='POL'">{{ $t('newPolRequest.ssvermNSonTarix') }}</label>
              <label v-else-if="['REV','AUC','LOG','RFQ'].indexOf(request.requestType)>-1">
                {{ $t('newRFQRequest.tklifNSonTarix') }}
              </label>
              <label v-else>{{ $t('newInfoRequest.sorununBitmTarixi') }}</label>

              <DatePicker
                v-model="requestDeadline"
                mode="dateTime"
                is24hr
                :minute-increment="15"
                :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                :min-date="minDeadline"
                :is-required="true"
                :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
              >
                <template #default="{ inputValue, inputEvents }">
                  <input
                    type="text"
                    class="form-control "
                    :value="inputValue"
                    placeholder=""
                    required
                    v-on="inputEvents"
                  >
                </template>
              </DatePicker>
            </div>

            <div
              v-if="requestType === 'PQT' && requestDeadline "
              class="mb-3 w-50"
            >
              <label>{{ $t('newRFQRequest.qalibinElanOlunmaTarixi') }}</label>

              <DatePicker
                v-model="orderExtras.winnerDeadline"
                mode="dateTime"
                is24hr
                :minute-increment="15"
                :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                :min-date="requestDeadline"
                :is-required="true"
                :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
              >
                <template #default="{ inputValue, inputEvents }">
                  <input
                    type="text"
                    class="form-control "
                    :value="inputValue"
                    placeholder=""
                    required
                    v-on="inputEvents"
                  >
                </template>
              </DatePicker>
            </div>

            <div
              v-if="['LOG','RFQ','TRS','TRK','REV','AUC'].indexOf(request.requestType)===-1"
              class="mb-3"
            >
              <label>{{ $t('newInfoRequest.lavFayllar') }}</label> <br>
              <p>{{ $t('newInfoRequest.sorunuzlaBalLavFayllarYklyBilrsiniz') }}</p>

              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-sm btn-light-primary"
                  @click.prevent="selectPhoto(-1)"
                >
                  {{ $t('newInfoRequest.yeniFaylYkl') }}
                </button>
                <div
                  v-if="uploadProgress >0 && uploadProgress <100"
                  class="progress"
                >
                  <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{width: `${uploadProgress}%`}"
                  />
                </div>
              </div>
              <div
                v-if="requestFiles.length>0"
                class="w-50 mt-3"
              >
                <div
                  v-for="(f,i) in requestFiles"
                  :key="f.path"
                  class="requestFile py-1"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <a
                        :href="getPhoto(f.path,'')"
                        class="text-secondary"
                      >
                        <i class="fa fa-paperclip mr-1" />
                        {{ f.path.split('/').pop() }}
                      </a>
                    </div>

                    <div
                      class="d-flex align-items-center cursor-pointer"
                      href="#"
                      @click="deleteFile(i)"
                    >
                      <feather
                        type="x"
                        size="16"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="['OFR'].indexOf(request.requestType)===-1">
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-success">
                  <b-form-checkbox
                    v-model="requestIsPrivate"
                    :disabled="onlyVendors>0"
                    value="1"
                  >
                    {{ $t('newAUCRequest.mllifiGizlt') }} <br>

                    <span
                      v-if="requestIsPrivate"
                      class="text-danger"
                    >
                      {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}
                    </span>
                    <span
                      v-else
                      class="text-success"
                    >
                      {{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}
                    </span>
                  </b-form-checkbox>
                </div>
                <div
                  v-if="requestType==='PQT'"
                  class="d-flex flex-column  mt-2 mt-sm-0 p-3"
                  style="margin-left: 16rem; !important; border: 1px solid #2062fb"
                >
                  <h4>{{ $t("newRFQRequest.kotirovkaMetodunuSein") }}</h4>
                  <div class="checkbox checkbox-primary">
                    <b-form-checkbox
                      v-model="autoWinner"
                      value="1"
                    >
                      {{ $t('newAUCRequest.manual') }}
                    </b-form-checkbox>
                  </div>
                  <div class="checkbox checkbox-primary mt-2">
                    <b-form-checkbox
                      v-model="autoWinner"
                      value="2"
                    >
                      {{ $t('newAUCRequest.automatic') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="requestType !=='OFR'"
              class=" "
            >
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-success ">
                  <b-form-checkbox
                    v-model="requestIsPersonalAllowed"
                    value="1"
                  >
                    {{ $t('editRequest.frdiVensizXslrSorunuCavablayaBilsinmi') }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div class=" ">
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-success ">
                  <b-form-checkbox
                    v-model="onlyVerified"
                    value="1"
                  >
                    {{ $t('newAUCRequest.ancaqTsdiqlnmiIrktIstifadilriCavablayaBilsin') }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div v-if="['RFQ','PQT','REV','LOG','LGI','TRS','CSI','WHI'].indexOf(requestType)>-1">
              <div class=" d-flex align-items-center">
                <div class="checkbox checkbox-success">
                  <b-form-checkbox
                    v-model="onlyVendors"
                    value="1"
                    :disabled="!vendorManagementAvailable || requestIsPrivate>0 "
                  >
                    {{ $t('newInfoRequest.ancaqTsdiqlnmiTdarklrimCavablayaBilsin') }}
                    <br>
                    <span
                      v-if="!vendorManagementAvailable"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.buFunksiyanIstifadEtmkN') }} <strong>{{ $t('newInfoRequest.vendorManagement') }}</strong> {{ $t('newInfoRequest.lavsiniAktivldirmlisniz') }}
                      <router-link :to="{name: 'addOnPage'}">{{ $t('newInfoRequest.aktivldir') }}</router-link>
                    </span>
                    <span
                      v-if="requestIsPrivate>0"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.gizliSorularNBuFunskiyaAktivDeyil') }}
                    </span>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <button class="btn  btn-primary">
            {{ $t('sectorSelectionModal.yaddaSaxla') }}
          </button>

          <button
            type="button"
            class="btn  btn-light ml-2"
            @click.prevent="$router.go(-1)"
          >
            {{ $t('companyProfile.lvEt2') }}
          </button>
        </div>
      </form>


      <b-modal
        id="modal-sector-selection"
        centered
        :title="$t('companyProfile.faliyytSahsiniSein')"
        scrollable
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="false"
        class="theme-modal"
        :busy="false"
        :hide-footer="true"
      >
        <sector_selection_modal
          :parent-sector="null"
          :selected="requestSectors"
          :max-selection="5"
          @done="($event)=>{requestSectors = $event;$bvModal.hide('modal-sector-selection') }"
        />
      </b-modal>
    </div>
    <div v-else>
      <div class="alert alert-info">
        {{ $t('login.yklnir') }}
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  editRequest, getRequestDetails, getVendorManagementStatus,
  getWorkingSectors, upload
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import {buildLongId, deliveryTypes, getPhoto, loadTypes, truckTypes} from "@/repositories/Utils";
import moment from 'moment'
import Sector_path from "@/components/sector_path.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import dayjs from "dayjs";

export default {
  components: {
    SelectedSectorView,
    Sector_selection_modal,
    Sector_path,
    Multiselect, Datepicker
  },
  data() {
    return {
      mediaBase: mediaBase,
      requestType: '',
      requestSubType: '',
      faq: [],
      request: null,
      requestTitle: '',
      requestDescription: '',
      requestIsPrivate: 0,
      requestIsPersonalAllowed: 0,
      onlyVerified: 0,
      onlyVendors: 0,
      requestDeadline: '',
      requestPhoto: '',
      autoWinner:'',
      requestSectors: [],
      sectors: [],
      uploadProgress: 0,
      requestFiles: [],
      orderExtras: {
        pickUpCountry: '',
        pickUpCity: '',
        pickUpAddress: '',
        dropOffCountry: '',
        dropOffCity: '',
        dropOffAddress: '',
        deadline: '',
        notes: '',
        incoterms: '',
        types: [],
        loadSize: '',
        loadUnit: '',
        startingPrice: 0,
        multiSelect: 0,
        ownVariant: 0
      },
      format: "dd MMM yyyy",
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      loadUnits: this.$t("loadUnits"),
      vendorManagementAvailable: false
    };
  },
  watch: {
    onlyVerified(newVal) {
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("prtlHzrkMrhlRsmAdmnOlan"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("onlyVendorModalText"),
          icon: 'warning'
        })
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      profile: state => state.auth.profile,
    }),

    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    },

    truckTypeList() {

      let list = [];

      Object.keys(truckTypes()).forEach((k) => {
        let v = truckTypes()[k];
        v.key = k;

        list.push(v);
      })

      return list;

    },
  },
  mounted() {

    getRequestDetails(this.token, this.$route.params.id).then(data => {

          if (data.code === 200) {

            if (data.request.user.id !== this.user.id || data.request.company.id !== this.company.id) {
              this.$swal({
                title: this.$t("err"),
                text: this.$t("ylnzOzSrgnlnDzl"),
                type: "warning"
              }).then(() => {
                this.$router.push({name: "request", params: {id: this.$route.params.id}});
              })
            } else {

              //setting field values
              this.request = data.request;
              this.requestType = data.request.requestType;
              this.requestSubType = data.request.requestSubType;

              this.requestSectors = data.sectors;
              this.requestFiles = data.files;
              this.autoWinner = data.request.autoWinner;
              this.requestTitle = data.request.title;
              this.requestDescription = data.request.description;
              this.requestPhoto = data.request.photo;
              this.requestIsPrivate = data.request.private ? 1 : 0;
              this.requestIsPersonalAllowed = data.request.personalAllowed ? 1 : 0;
              this.onlyVendors = data.request.onlyVendors ? 1 : 0;
              this.onlyVerified = data.request.onlyVerified ? 1 : 0;
              this.requestDeadline = data.request.requestDeadline;

              let jsonExtras = JSON.parse(data.request.extras)
              this.orderExtras = {
                pickUpCountry: jsonExtras.pickupCountry,
                pickUpCity: jsonExtras.pickupCity,
                pickUpAddress: jsonExtras.pickupAddress,
                dropOffCountry: jsonExtras.dropOffCountry,
                dropOffCity: jsonExtras.dropOffCity,
                dropOffAddress: jsonExtras.dropOffAddress,
                deadline: moment(jsonExtras.offerDeadline).toDate(),
                notes: jsonExtras.notes,
                incoterms: jsonExtras.incoterms,
                loadSize: jsonExtras.volume,
                loadUnit: jsonExtras.unit,
                startingPrice: jsonExtras.startingPrice,
                ownVariant: jsonExtras.ownVariant,
                multiSelect: jsonExtras.multiSelect,
                minOrder: jsonExtras.minOrder,
                unit: jsonExtras.unit,
                price: jsonExtras.price,
                payment: jsonExtras.payment,
                delivery: jsonExtras.delivery,
                currency: jsonExtras.currency,
                currencyRequired: jsonExtras.currencyRequired,
                incotermsRequired: jsonExtras.incotermsRequired,
                paymentRequired: jsonExtras.paymentRequired,
                deliveryNeeded: jsonExtras.deliveryNeeded,
                initialRequirementNotes: jsonExtras.initialRequirementNotes,
                winnerDeadline: moment(jsonExtras.winnerDeadline).toDate(),
                truckType: '',
                driverHasAdr: jsonExtras.driverHasAdr,
                priceVolume:  jsonExtras.priceVolume ,
                pricePrice:  jsonExtras.pricePrice ,
                priceNotes: jsonExtras.priceNotes,
              };

              if (jsonExtras.types) {
                let l = jsonExtras.types.split(',')

                if (this.request.requestType === 'TRK') {
                  this.orderExtras.types = this.advTypeList.filter(t => {
                    return l.indexOf(t.key) > -1
                  })
                } else if (this.request.requestType === 'LOG') {
                  this.orderExtras.types = this.typeList.filter(t => {
                    return l.indexOf(t.key) > -1
                  })
                }
              }

              if(jsonExtras.truckType){
                this.orderExtras.truckType =  truckTypes()[jsonExtras.truckType];
              }

            }
          } else {
            this.$swal({
              title: this.$t("err"),
              text: `${data.message}`,
              type: "warning"
            }).then(() => {
              this.$router.push({name: "request", params: {id: this.$route.params.id}});
            })

          }

        }
    )

    getWorkingSectors(this.$i18n.locale).then(data => {
      this.sectors = data;
    })


    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })

  },
  methods: {
    validateSelection() {
      if (this.autoWinner === null|| this.autoWinner===false) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: `${this.$t("newRFQRequest.kotirovkaMetodunuSein")}`,
          icon: 'error'
        })
        return false;
      }
      // Proceed with form submission or next steps
      return true;
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    createRequest() {
      if (this.requestType ==='PQT' &&  !this.validateSelection())
        return;
      let sectors = this.requestSectors.map(function (elem) {
        return elem.id;
      }).join(",");
      switch (this.request.requestType) {
        case "LGI":
        case "LOG":
        case "TRS":
          sectors = 13;
          break;
        case "CSI":
          sectors = 14;
          break;
        case "WHI":
          sectors = 12;
          break;
        case "OFR":
          if (this.profile === 'LOGISTIC') {
            sectors = 13;
          }
          break;

      }

      let extras = {};
      if (this.request.requestType === 'PQT') {
        let winnerDeadlineFormatted = moment(this.orderExtras.winnerDeadline).format('YYYY-MM-DD HH:mm:ss');

        extras = {
          "version": "1.0.0",
          "currency": this.orderExtras.currency,
          "currencyRequired": this.orderExtras.currencyRequired,
          "incoterms": this.orderExtras.incoterms,
          "incotermsRequired": this.orderExtras.incotermsRequired,
          "payment": this.orderExtras.payment,
          "paymentRequired": this.orderExtras.paymentRequired,
          "deliveryNeeded": this.orderExtras.deliveryNeeded,
          "delivery": `${this.orderExtras.delivery}`,
          "initialRequirementNotes": this.orderExtras.initialRequirementNotes,
          "winnerDeadline": winnerDeadlineFormatted
        };
      } else if (this.request.requestType === 'AUC') {

        extras = {
          "version": "1.0.0",
          "startingPrice": this.orderExtras.startingPrice
        };
      } else if (this.request.requestType === 'POL') {

        extras = {
          "version": "1.0.0",
          "multiSelect": this.orderExtras.multiSelect,
          "ownVariant": this.orderExtras.ownVariant
        };
      } else if (this.request.requestType === 'LOG') {
        let deadlineFormatted = moment(this.requestDeadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "pickupAddress": this.orderExtras.pickUpAddress,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "dropOffAddress": this.orderExtras.dropOffAddress,
          "offerDeadline": deadlineFormatted,
          "notes": this.orderExtras.notes,
          "incoterms": this.orderExtras.incoterms,
          "types": this.orderExtras.types.map((t) => {
            return t.key;
          }).join(","),
        };
      } else if (this.request.requestType === 'TRS') {
        let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "pickupAddress": this.orderExtras.pickUpAddress,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "dropOffAddress": this.orderExtras.dropOffAddress,
          "offerDeadline": deadlineFormatted,
        };
      } else if (this.request.requestType === 'TRK') {

        let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "volume": this.orderExtras.loadSize,
          "unit": this.orderExtras.loadUnit,
          "offerDeadline": deadlineFormatted,
          "types": this.orderExtras.types.map((t) => {
            return t.key;
          }).join(","),
          truckType: this.orderExtras.truckType.key,
          driverHasAdr: this.orderExtras.driverHasAdr,
          priceVolume: this.orderExtras.priceVolume,
          pricePrice: this.orderExtras.pricePrice,
          priceNotes: this.orderExtras.priceNotes,
        };
      } else if (this.requestType === 'OFR') {

        if (this.requestSubType === 'wholesale') {
          extras = {
            "version": "1.0.0",
            "minOrder": this.orderExtras.minOrder,
            "unit": this.orderExtras.unit,
            "price": this.orderExtras.price,
            "payment": this.orderExtras.payment,
            "delivery": this.orderExtras.delivery,
          };
        } else if (this.requestSubType === 'retail') {
          extras = {
            "version": "1.0.0",
            "payment": this.orderExtras.payment,
            "delivery": this.orderExtras.delivery,
          };
        } else if (this.requestSubType === 'service') {
          extras = {
            "version": "1.0.0",
            "payment": this.orderExtras.payment,
          };
        }

      }


      if (this.requestTitle !== '' && (['LOG', 'TRS', 'TRK'].indexOf(this.request.requestType) > -1 || this.requestDescription !== '') && sectors !== '') {

        editRequest(
            this.token, this.request.id,
            sectors,
            this.requestTitle, this.requestFiles, this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate, this.requestIsPersonalAllowed,
            this.onlyVerified, this.onlyVendors,
            JSON.stringify(extras) , this.autoWinner
        ).then(data => {

          if (data.code === 200) {

            this.$router.replace('/dashboard/request/' + this.request.id);

          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })

      }

    },

    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    deleteFile(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.requestFiles.splice(index, 1);
      }
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'requestPhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                this.requestFiles.push({
                  id: 0,
                  path: response.data.path,
                  type: "request"
                });

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              console.log(e);
              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },


  }

}
</script>

<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
